import { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';
import useDataBean from '../../../../../../../core/services/dataBean/useDataBean';
import { _ScheduleEmployeeBonus } from '../../../../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicTable } from '../../../../../../theme/Component/BasicTable';
import usePaginator from '../../../../../../theme/Component/usePaginator';


interface Props {
    idScheduleEmployeeBonus: number;
}

export const ScheduleEmployeeBonusItem = ({ idScheduleEmployeeBonus }: Props) => {
    const { instance, lista, setLista, bean, setBean } = useDataBean(_ScheduleEmployeeBonus);
    const paginador = usePaginator();

    const getLista = useCallback(() => {
        if (!idScheduleEmployeeBonus) {
            setLista([]);
            return;
        }

        instance.getScheduleEmployeeBonusItemCatalog(idScheduleEmployeeBonus, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15);
                setLista(resp.List ?? [])
            }
        ).catch((err: any) => toast.error(err));
    }, [idScheduleEmployeeBonus]);


    useEffect(() => {
        getLista();
    }, [getLista]);

    const head = [
        { title: 'ID', property: 'IDScheduleEmployeeBonusItem', visible: true },
        { title: 'IDContract', property: 'IDContrato', visible: true },
        { title: 'Fecha Inicial', property: 'FromDate', visible: true },
        { title: 'Fecha Final', property: 'UptoDate', visible: true },
        { title: 'Base de Liquidación', property: 'BaseValue', visible: true },
        { title: 'Beneficio Liquidado', property: 'BenefitValue', visible: true },
        { title: 'Unidades Liquidación', property: 'TimeUnits', visible: true },
    ];

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    head={head}
                    body={lista}
                    rowSet={setBean}
                />
            </div>
        </div>
    );
};
